import { osName } from 'react-device-detect';

import { useClientHasRendered } from '@domain/session/useClientHasRendered';

export const useGetOsName = (): string => {
  const clientHasRendered = useClientHasRendered();
  return clientHasRendered ? osName : '';
};
